export const checkCEP = async (cep: string, values: any, isload: (load: boolean) => void) => {
    const sanitizedCep = cep.replace(/\D/g, ''); // Remove caracteres não numéricos
    if (sanitizedCep !== '' && sanitizedCep.length === 8) {
        try {
            isload(true);
            const response = await fetch(`https://viacep.com.br/ws/${sanitizedCep}/json/`);
            const data = await response.json();

            if (!data.erro) {
                values(data);
            } else {
                alert('CEP não encontrado.');
            }
        } catch (error) {
            console.error('Erro ao buscar o CEP:', error);
        } finally {
            isload(false);
        }
    } else {
        alert('CEP inválido. Por favor, insira um CEP válido.');
    }
};
